var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"adminLoginPage"},[_c('div',{staticClass:"auth-container container"},[_c('div',{staticClass:"card-container card border-0 row"},[_c(_vm.selectedRoute,{tag:"component"}),_c('TheFooter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }